import * as React from "react";
import Dialog, { DialogProps } from "@material-ui/core/Dialog";
import { DialogTitle, DialogContent, Typography, DialogActions, Button } from "@material-ui/core";

interface ConfirmDialogProps extends DialogProps {
  titleText: string;
  contentText: string;
  cancelButtonText?: string;
  confirmButtonText?: string;
  onCancelClick?: (e: React.MouseEvent<Element>) => void;
  onConfirmClick?: (e: React.MouseEvent<Element>) => void;
  contentTextClassName?: string;
}

class ConfirmDialog extends React.PureComponent<ConfirmDialogProps> {
  render() {
    const {
      titleText,
      contentText,
      confirmButtonText,
      cancelButtonText,
      onCancelClick,
      onConfirmClick,
      contentTextClassName,
      ...other
    } = this.props;
    return (
      <Dialog {...other}>
        <DialogTitle>{titleText}</DialogTitle>
        <DialogContent>
          {contentText != null && <Typography className={contentTextClassName}>{contentText}</Typography>}
          {this.props.children}
        </DialogContent>
        <DialogActions>
          {onCancelClick && (
            <Button variant="outlined" onClick={onCancelClick}>
              {cancelButtonText || "Cancel"}
            </Button>
          )}
          {onConfirmClick && (
            <Button variant="contained" color="secondary" onClick={onConfirmClick}>
              {confirmButtonText || "Confirm"}
            </Button>
          )}
        </DialogActions>
      </Dialog>
    );
  }
}

export default ConfirmDialog;
